import { ARSupport, Main } from './main';
import { ArilynLibrary } from './ALEvents';

export class UI {
  private readonly linkClicked = new ArilynLibrary.ALEvent<number>();
  public get LinkClickedEvent() {
    return this.linkClicked.expose();
  }

  private readonly webXRClicked = new ArilynLibrary.ALEvent<number>();
  public get WebXRClickedEvent() {
    return this.webXRClicked.expose();
  }

  main: Main;

  constructor(main: Main) {
    this.main = main;
    this.createButtons();
  }

  private createButtons() {
    if (this.main.arSupport == ARSupport.WebXR) {
      const button = document.querySelector('.enter-webxr') as HTMLButtonElement | null;
      if (button) {
        button.onclick = () => this.webXRClicked.invoke();
      }
    } else if (this.main.arSupport == ARSupport.USDZ) {
      const button = document.querySelector('.enter-arkit') as HTMLAnchorElement | null;
      if (button) {
        button.rel = 'ar';
        button.onclick = () => {
          document.documentElement.classList.add('loading-ar');
        };
        button.addEventListener(
          'message',
          (event: any) => {
            if (event.data == '_apple_ar_quicklook_button_tapped') {
              this.linkClicked.invoke();
            }
          },
          false
        );
      }
    }
  }
}
